export default {
	attendance: "Atendimento",
	inProgress: "Em Andamento",
	selectConsultant: "Selecionar Consulente",
	searchConsultant: "Buscar pessoa para consulta",
	createNewConsultant: "Cadastrar Nova Pessoa",
	typeToSearch: "Digite para buscar consulentes",
	noConsultantsFound: "Nenhum consulente encontrado",
	changeConsultant: "Alterar",
	loadingHistory: "Carregando histórico...",
	noHistoryFound: "Nenhum histórico encontrado para este consulente",
	errorLoadingHistory: "Erro ao carregar histórico do consulente",
	mediumName: "Médium",
	ticketAssignedSuccess: "Ficha atribuída com sucesso!",
	consultationFinishedSuccess: "Consulta finalizada com sucesso!",
	ticketCancelledSuccess: "Ficha cancelada com sucesso!",
	ticketDeletedSuccess: "Ficha excluída com sucesso!",
	noActiveRitual: "Nenhum ritual em andamento no momento",
	errorLoadingRitual: "Erro ao carregar informações do ritual",
	ritualNotAvailable: "Este ritual não está disponível para distribuição de fichas",
	errorLoadingConsultant: "Erro ao carregar consulente",
	errorLoadingConsultants: "Erro ao carregar consulentes",
	errorCreatingTicket: "Erro ao criar ficha de atendimento",
	consultantAlreadyHasTicket: "Este consulente já possui ficha ativa neste ritual",
	consultantHasCancelledTicket: "Este consulente possui ficha cancelada neste ritual",
	ticketSlotOccupied: "Esta posição de ficha já está ocupada",
	assignTicket: "Atribuir Ficha",
	selected: "Selecionada",
	clickToDeselect: "Clique para desselecionar",
	clickToSelect: "Clique para selecionar posição",
	alreadyHasTicket: "Esta pessoa já possui ficha neste ritual",
	consultantInfo: "Informações do Consulente",
	ticketDetails: "Detalhes da Ficha",
	consultationTime: "Horário da Consulta",
	viewProfile: "Ver Perfil",
	finishConsultation: "Finalizar Consulta",
	cancelTicket: "Cancelar Ficha",
	deleteTicket: "Excluir Ficha",
	status: {
		pending: "Pendente",
		in_progress: "Em Atendimento",
		completed: "Concluída",
		cancelled: "Cancelada",
	},
	confirmCancel: "Confirmar Cancelamento",
	confirmCancelMessage: "Tem certeza que deseja cancelar esta ficha? O consulente ficará bloqueado neste ritual.",
	confirmDelete: "Confirmar Exclusão",
	confirmDeleteMessage: "Tem certeza que deseja excluir esta ficha? O consulente poderá pegar uma nova ficha.",
	cardInfo: "Ficha / Médium · Guia",
	addTicket: "Adicionar",
	selectConsultantFirst: "Selecione um consulente primeiro",
	cardFull: "Esta ficha está cheia",
	onlyDuringInProgress: "Disponível apenas quando o ritual estiver em andamento",
	noTicketsYet: "Nenhuma ficha distribuída ainda",
	noAttendanceCards: "Nenhuma ficha de atendimento configurada para este tipo de ritual",
	noAttendanceCardsHint: "Verifique se o tipo de ritual possui tipos de atendimento vinculados nas configurações.",
	errorLoadingCards: "Erro ao carregar fichas de atendimento",
	showNames: "Mostrar nomes",
	hideNames: "Ocultar nomes",
	hasReservation: "Reserva garantida",
	totalTickets: "Fichas",
	pendingCount: "Pendentes",
	preSenha: {
		title: "Pré-senha",
		called: "Pré-senha {number} chamada",
		resetSuccess: "Pré-senha zerada",
		errorCalling: "Erro ao chamar pré-senha",
		errorResetting: "Erro ao zerar pré-senha",
	},
};
